<template>
  <div class="text-center">
    <UiHeading type="h4" class="mb-4 text-primary-400">{{ subtitle }}</UiHeading>
    <UiHeading type="h1" class="mb-8">{{ title }}</UiHeading>
    <UiSlider :id="id" :show-arrows="showArrows" direction="horizontal">
      <ProductListCard
        v-for="product of products"
        :key="product.id"
        :product="product"
        class="shrink-0 basis-2/3 text-left md:!w-full md:basis-[calc(25%-0.75rem)]"
      />
    </UiSlider>
  </div>
</template>

<script lang="ts" setup>
import type { ProductSliderProps } from './types';

defineProps<ProductSliderProps>();
</script>
